module.exports = __webpack_public_path__ + "img/img-5.a059f6f2.jpg";